import axios from 'axios';

// import router from '@/router';
import auth from '@/utils/auth';

import {
  GET_AGM_PRESENCE,
  GET_AGM_PRESENCE_ERROR,
  GET_AGM_PRESENCE_SUCCESS,

  UPDATE_AGM_PRESENCE,
  UPDATE_AGM_PRESENCE_ERROR,
  UPDATE_AGM_PRESENCE_SUCCESS,

  GET_PRESENCE,
  GET_PRESENCE_ERROR,
  GET_PRESENCE_SUCCESS,

  SAVE_AGM_PRESENCE,
  SAVE_AGM_PRESENCE_ERROR,
  SAVE_AGM_PRESENCE_SUCCESS,

  DELETE_AGM_PRESENCE,
  DELETE_AGM_PRESENCE_ERROR,
  DELETE_AGM_PRESENCE_SUCCESS,

  DOWNLOAD_AGM_PRESENCE,
  DOWNLOAD_AGM_PRESENCE_ERROR,
  DOWNLOAD_AGM_PRESENCE_SUCCESS,


} from './constants';

export default {

  async [DELETE_AGM_PRESENCE]({ commit }, data) {
    const id = data[0].agmPresenceID;
    try {
      commit(DELETE_AGM_PRESENCE);
      await axios({
        url: `${process.env.API_URL}/api/agm-presence/${id}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_AGM_PRESENCE_SUCCESS);
    } catch (err) {
      commit(DELETE_AGM_PRESENCE_ERROR, err);
    }
  },

  async [DOWNLOAD_AGM_PRESENCE]({ commit }, args) {
    try {
      commit(DOWNLOAD_AGM_PRESENCE);
      const response = await axios({
        url: `${process.env.API_URL}/api/agm-presence/publish/pdf`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          syndicateID: args.syndicateID,
          reunionDate: args.reunionDate,
        },
      });
      commit(DOWNLOAD_AGM_PRESENCE_SUCCESS, response.data);
    } catch (err) {
      commit(DOWNLOAD_AGM_PRESENCE_ERROR, err);
    }
  },

  async [GET_AGM_PRESENCE]({ commit }, args) {
    try {
      commit(GET_AGM_PRESENCE);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${args.syndicateID}/agm-presence`,
        method: 'GET',
        headers: auth.getAuthHeader(),
        params: {
          reunionDate: args.reunionDate,
        },
      });
      commit(GET_AGM_PRESENCE_SUCCESS, response.data);
    } catch (err) {
      commit(GET_AGM_PRESENCE_ERROR, err);
    }
  },

  async [GET_PRESENCE]({ commit }) {
    try {
      commit(GET_AGM_PRESENCE);
      const response = await axios({
        url: `${process.env.API_URL}/api/agm/presence`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_PRESENCE_SUCCESS, response.data);
    } catch (err) {
      commit(GET_PRESENCE_ERROR, err);
    }
  },

  async [SAVE_AGM_PRESENCE]({ commit }, data) {
    // const { agm, rowIndex } = data;
    try {
      commit(SAVE_AGM_PRESENCE);
      const url = `${process.env.API_URL}/api/agm-presence`;
      const method = 'POST';
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_AGM_PRESENCE_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_AGM_PRESENCE_ERROR, err);
    }
  },
  async [UPDATE_AGM_PRESENCE]({ commit }, data) {
    // const { agm, rowIndex } = data;
    try {
      commit(UPDATE_AGM_PRESENCE);
      const url = `${process.env.API_URL}/api/agm-presence/update`;
      const method = 'PUT';
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(UPDATE_AGM_PRESENCE_SUCCESS, response.data);
    } catch (err) {
      commit(UPDATE_AGM_PRESENCE_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Reports/AGM/actions.js